import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/rootStore';
import { setLogsFilter } from '../store/logs.store';
import LogsFilter from '../components/LogsFilter';
import useLogs from '../hooks/useLogs';

const LogsFilterContainer: React.FC = () => {
  const { groupOptions, selectedGroup, onGroupChange } = useLogs();
  const { filter } = useSelector((state: RootState) => state.logs);
  const dispatch = useDispatch<any>();
  const handleSelectTypes = React.useCallback((types: string[]) => dispatch(setLogsFilter({ types })), [dispatch]);
  return (
    <LogsFilter
      selectedTypes={filter.types}
      onSelectTypes={handleSelectTypes}
      groupOptions={groupOptions}
      selectedGroup={selectedGroup || undefined}
      onGroupChange={onGroupChange}
    />
  );
};

export default LogsFilterContainer;
